<template>

  <div class="py-4 container-fluid">
    <div class="row">


      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <div class="row" style="width: 100%;">
                <div class="col-md-6">
              <p class="mb-0">Crear Producto</p>
            </div>
            <div class="col-md-6">
              <argon-button v-if="form.status != 1 && ((user.role!=='1' && form.status==0) || user.role==='1')"  color="success" size="sm" class="ms-auto"  @click="save"
                >Borrador</argon-button>
              <argon-button v-if="(user.role!=='1' && form.status==0) || (user.role==='1'  && form.status==0 ) && form.id!=0"   color="warning" size="sm" class="" style="margin-left: 5px;"  @click="confirm"
                >Guardar</argon-button>
              </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label"
                  >Proveedor</label>
                <div class="d-flex gap-2">
                  <select class="form-select flex-grow-1" v-model="form.supplier_id" @change="selectSupplier" :disabled="form.status == 1">
                    <option value="">Seleccione un proveedor</option>
                    <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
                      {{ supplier.name }}
                    </option>
                  </select>
                  <argon-button v-if="form.status != 1" color="success" size="sm" @click="openAddSupplierModal"><i class="fa fa-user-plus"></i></argon-button>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="form.id!=0">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de compras</p>
              <argon-button v-if="form.status != 1 && user.role==='1'"  color="success" size="sm" class="ms-auto" @click="openModal"
                >Agregar compra</argon-button>
              <argon-button v-if="form.status != 1 && user.role!=='1' && form.status==0" color="success" size="sm" class="ms-auto" @click="openModal"
                >Agregar compra</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Cantidad (Und - Mts)</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Precio Unidad</th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center" v-if="(user.role!=='1' && form.status===0) || user.role==='1'"   >
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.inventory.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.quantity }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat( value.price ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat( value.total_price ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ new Date(value.updated_at).toLocaleDateString('es-ES') }} 
                        </span>
                      </td>
                      
                      <td class="align-middle text-center" v-if="(user.role!=='1' && form.status===0) || user.role==='1'"  >
                    
                        <a
                          @click="deleteRegister(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Eliminar registro" 
                        >
                        <i class="fa fa-trash"></i>
                      </a>
                      
                    

                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  <!-- Modal Asignar tecnico -->
  <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar compra</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label for="amount" class="form-label">Insumo</label>
              <select v-model="purchase.inventory_id" ref="processesSelect" id="processes" class="form-select select2" style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} ({{ process.ref }})
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="amount" class="form-label">Cantidad (Und - Mts)</label>
              <input type="text" v-model="purchase.quantity" id="amount" class="form-control" placeholder="Ingrese el valor">
            </div>
            <div class="mb-3">
              <label for="amount" class="form-label">Precio Unidad</label>
              <input type="text"  v-model="formattedPrice"  id="amount" class="form-control" placeholder="Ingrese el valor">
            </div>
            <div class="mb-3">
              <label for="amount" class="form-label">Total</label>
              <input type="text"  v-model="totalPrice" id="total_price" class="form-control" placeholder="Ingrese el valor total">
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar Proveedor -->
  <div class="modal fade" id="ModalAddSupplier" tabindex="-1" aria-labelledby="addSupplierModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="addSupplierModalLabel">Agregar Proveedor</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="supplier-name" class="form-label">Nombre *</label>
              <input type="text" v-model="newSupplier.name" id="supplier-name" class="form-control" placeholder="Ingrese el nombre" required>
            </div>
            <div class="mb-3">
              <label for="supplier-email" class="form-label">Email *</label>
              <input type="email" v-model="newSupplier.email" id="supplier-email" class="form-control" placeholder="Ingrese el email" required>
            </div>
            <div class="mb-3">
              <label for="supplier-phone" class="form-label">Teléfono *</label>
              <input type="text" v-model="newSupplier.phone" id="supplier-phone" class="form-control" placeholder="Ingrese el teléfono" required>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAddSupplierModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveSupplier">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</div>


  
</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
//import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import userService from '../../../services/user.service';

const body = document.getElementsByTagName("body")[0];

export default {
name: "Models Create",
data() {
  return {
    showMenu: false,
    modalBudget:null,
    isFinish:false,
    user:{},
    form: {
      id:0,
      supplier_id: '',
      supplier: '',
      phone: '',
      email: '',
      status: 0,
    },
    size:{
      size:'',
      color_id:'',
      model_id:'',
      quantity:0,
      status:1
    },
    insumos: [],
    colors: [],
    sizes:[],
    purchases:[],
    purchase:{
      purchase_id:0,
      inventory_id:0,
      quantity:0,
      price:0,
      total_price:0,
    },
    data: {},
    modal: {
      id:0,
      user_id: null,
      project_id: null,
      amount: "",
      status: "active"
    },
    modalEvidencia: [],
    suppliers: [],
    filteredSuppliers: [],
    modalAddSupplier: null,
    newSupplier: {
      name: '',
      email: '',
      phone: '',
      password: 'ProveedorMotopiruetas',
      password_confirmation: 'ProveedorMotopiruetas',
      role: '5', // Proveedor
      status: 1,
      payment: '0', // 0 = Mensualidad, 1 = Por Tarea
    },
  };
},
components: { ArgonButton },
computed: {
  formattedPrice: {
    get() {
      return this.purchase.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    set(value) {
      this.purchase.price =  Math.floor(value.replace(/\./g, "") || 0);
      this.purchase.total_price =  Math.floor(this.purchase.price * this.purchase.quantity);
    },
  },
  totalPrice: {
    get() {
      return this.purchase.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    set(value) {
      this.purchase.total_price =  Math.floor(value.replace(/\./g, "") || 0);
      this.purchase.price = this.purchase.quantity > 0 ?  Math.floor((this.purchase.total_price / this.purchase.quantity))  : 0; 
    },
  },
},
methods: {
  async getSuppliers(){
    try {
      const response = await userService.getAll('all');
      const allUsers = response.data.data || response.data || [];
      // Filtrar solo proveedores (role === '5')
      this.suppliers = allUsers.filter(user => user.role === '5');
    } catch (error) {
      console.error('Error fetching suppliers:', error);
    }
  },
  selectSupplier() {
    const selectedSupplier = this.suppliers.find(s => s.id == this.form.supplier_id);
    if (selectedSupplier) {
      this.form.supplier = selectedSupplier.name;
      this.form.email = selectedSupplier.email || '';
      this.form.phone = selectedSupplier.phone || '';
    }
  },
  openAddSupplierModal() {
    const modalElement = document.getElementById('ModalAddSupplier');
    this.modalAddSupplier = new Modal(modalElement);
    this.modalAddSupplier.show();
  },
  closeAddSupplierModal() {
    if (this.modalAddSupplier) {
      this.modalAddSupplier.hide();
    }
    // Resetear formulario
    this.newSupplier = {
      name: '',
      email: '',
      phone: '',
      password: '',
      password_confirmation: '',
      role: '5',
      status: 1,
      payment: '0', // 0 = Mensualidad, 1 = Por Tarea
    };
  },
  async saveSupplier() {
    try {
      // Validar campos requeridos
      if (!this.newSupplier.name || !this.newSupplier.email || !this.newSupplier.phone || !this.newSupplier.password) {
        Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
        return;
      }

      if (this.newSupplier.password !== this.newSupplier.password_confirmation) {
        Swal.fire('Error', 'Las contraseñas no coinciden', 'error');
        return;
      }

      // Crear el proveedor
      const response = await userService.createUser(this.newSupplier);
      
      if (response && response.status >= 200 && response.status < 300) {
        Swal.fire('Éxito', 'Proveedor creado correctamente', 'success');
        this.closeAddSupplierModal();
        // Recargar lista de proveedores
        await this.getSuppliers();
        // Seleccionar el proveedor recién creado
        this.form.supplier_id = response.data.id;
        this.selectSupplier();
      } else {
        throw new Error(response?.data?.message || 'Error al crear el proveedor');
      }
    } catch (error) {
      console.error('Error creating supplier:', error);
      const errorMsg = error.response?.data?.message || error.message || 'Error al crear el proveedor';
      Swal.fire('Error', errorMsg, 'error');
    }
  },
  getIconClass(status) {
    if (status === 0) {
      return 'fa fa-circle'; // Ícono de clic
    } else if (status === 1) {
      return 'fa fa-check-circle text-success'; // Ícono de check verde
    } else if (status === 2) {
      return 'fa fa-times-circle text-danger'; // Ícono de X roja
    }
    return ''; // Devuelve una cadena vacía si no coincide con ningún estado
  },
  openModal() {
    const modalElement = document.getElementById('ModalBudget');
    this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
    this.modalBudget.show(); // Muestra el modal
  },
  closeModal() {
    if (this.modalBudget) {
      this.modalBudget.hide(); // Cierra el modal
    }
  },
  async getData() {
    await this.$store.dispatch('purchasesDetails/getData',this.form.id); 
    this.data =this.$store.state.purchasesDetails.getData;
  },
  async getInsumos() {
    this.insumos = await this.$store.dispatch('inventory/getAll'); 
  },
  async confirm() {
    
    await Swal.fire({
          icon: 'info',
          title: 'Formalizar compra',
          text: 'Al formalizar la compra ya no se podra editar los registros ni los detalles de la compra',
          confirmButtonText: 'Aceptar',
          backdrop: true,
      }).then((result) => {
          if (result.isConfirmed) {
            this.form.status = 1;
            this.save();
          }
      });
  },
  async save() {
    try {
      // Dispara la acción de Vuex para guardar el estudiante
      const response = await this.$store.dispatch("purchases/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
        }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;

              this.purchase.purchase_id =  response.data.id || 0;

            }
        });

      }else{
        throw new Error(response.data.message || 'Error al guardar el proyecto');
      }

    } catch (error) {
      console.error("Error al crear el proyecto:", error);
      await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
      });
    }
  },  
  async submitForm() {
    try {
      // Dispara la acción de Vuex para guardar el estudiante
      const response = await this.$store.dispatch("purchases/detailSave", this.purchase);
  
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
        }).then((result) => {
            if (result.isConfirmed) {

              this.purchase.inventory_id = 0;
              this.purchase.quantity = 0;
              this.purchase.price = 0;
              this.purchase.total_price = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
        });
      }else{
        throw new Error(response.data.message || 'Error al guardar el registro');
      }
      
    } catch (error) {
      console.error("Error al crear el registro:", error);
      await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
      });
    } 
  
  },
  async deleteRegister(userId) {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        const response = await this.$store.dispatch("purchasesDetails/delete", userId);
        if (response && response.status >= 200 && response.status < 300) {

          await Swal.fire(
            'Eliminado!',
            'El registro ha sido eliminado correctamente.',
            'success'
          );

          this.getData();
        } else {
          throw new Error(response.data.message || 'Error al eliminar el registro');
        }
      }
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error al eliminar el registro',
      });
    }
  },

},
async mounted() {

  this.user = JSON.parse(localStorage.getItem('user'));

  const route = useRoute();
  const dataEdit = route.params.data;

  // Cargar proveedores primero para que estén disponibles al cargar la compra
  await this.getSuppliers();

  this.getInsumos();

  if (dataEdit) {
   
     

      try {
          const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear

          this.data = params;
          if (params && params.id) {

              this.purchase.purchase_id = params.id || 0;

              this.form.id = params.id || 0;
              // Convertir supplier_id a número si existe
              this.form.supplier_id = params.supplier_id ? parseInt(params.supplier_id) : '';
              this.form.supplier = params.supplier || '';
              this.form.phone = params.phone || '';
              this.form.email = params.email || '';
              this.form.status = params.status || 0;
            
              // Si hay supplier_id, seleccionar el proveedor después de que se carguen los proveedores
              this.$nextTick(() => {
                if (this.form.supplier_id) {
                  this.selectSupplier();
                }
              });
            
              this.getData(); 
          }
      } catch (error) {
          console.error("Error al parsear los datos del registro:", error);
      }
  }

  this.$nextTick(() => {
    $(this.$refs.processesSelect).select2({
      placeholder: 'Seleccione un insumo',
      allowClear: true,
      dropdownParent: $('#ModalBudget .modal-body')
    });
    // Actualizar el valor cuando se seleccione una opción en select2
    $(this.$refs.processesSelect).on('change', () => {
      this.purchase.inventory_id = $(this.$refs.processesSelect).val();
    });
  });
  

  this.$store.state.isAbsolute = false;
  setNavPills();
  setTooltip();
},
beforeMount() {
  this.$store.state.imageLayout = "profile-overview";
  this.$store.state.showNavbar = true;
  this.$store.state.showFooter = true;
  this.$store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
},
beforeUnmount() {
  this.$store.state.isAbsolute = false;
  this.$store.state.imageLayout = "default";
  this.$store.state.showNavbar = true;
  this.$store.state.showFooter = true;
  this.$store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
}
};
</script>

<style>
.disabled-link {
color: gray;
pointer-events: none; /* Impide la interacción */
cursor: not-allowed; /* Cambia el cursor para indicar que está deshabilitado */
}
</style>


